import React, { Component } from 'react'
import { Router, Route, Switch } from 'react-router-dom'
import history from './history'
import Auth from './auth/auth'
import './App.css'
// Styles
// CoreUI Icons Set
import '@coreui/icons/css/coreui-icons.min.css'
// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css'
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css'
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css'
// Import Main styles for this application
import './scss/style.css'

// Containers
import { DefaultLayout } from './containers'
// Pages
import { Page404, Page500 } from './views/Pages'

// import { renderRoutes } from 'react-router-config';

const auth = new Auth()

const handleAuthentication = ({ location }) => {
  if (/access_token|id_token|error/.test(location.hash)) {
    auth.handleAuthentication()
  }
}

class App extends Component {
  render () {
    return (
      <Router history={history}>
        <Switch>
          <Route
            exact
            path='/callback'
            render={props => {
              handleAuthentication(props)
              return <div>Loading...</div>
            }}
          />
          <Route exact path='/404' name='Page 404' component={Page404} />
          <Route exact path='/500' name='Page 500' component={Page500} />
          <AuthenticatedRoutes />
        </Switch>
      </Router>
    )
  }
}

const AuthenticatedRoutes = () => {
  if (auth.isAuthenticated()) {
    return (
      <Route
        path='/'
        name='Home'
        render={() => <DefaultLayout logout={auth.logout} />}
      />
    )
  }

  auth.login()
  return null
}

export default App



// WEBPACK FOOTER //
// ./src/App.js